import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type GetCashierResponse as SchemaGetCashierResponse } from '../schemas/GetCashierResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const GetCashiersContentType = '' as const;
export type GetCashiersRequest = void;
export type GetCashiersResponses = LinkCommonErrorResponses & {
    /**
     * @description Cashiers list
     */
    '200': {
        'application/json': SchemaGetCashierResponse;
    };
};
export type GetCashiersResponseSuccess = GetCashiersResponses['200']['application/json'];
export type GetCashiersSearchParams = undefined;
export type GetCashiersPathParameters = undefined;
export const GetCashiersUrl = '/integrations/cashiers' as const;
export const GetCashiersMethod = 'GET' as const;
export const getGetCashiersUrl = (_params?: GetCashiersPathParameters) => GetCashiersUrl;
